module.exports = __webpack_public_path__ + "static/media/moustache-emoji-svgrepo-com.4081290c.svg";